import {FETCH_PO_FOR_TYPE_SUCESS} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  datas: [],
  resource: {},
  pageNo: 0
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case FETCH_PO_FOR_TYPE_SUCESS: {
      return {
        ...state,
        total: action.count,
        datas: action.datas,
        resource: action.resource,
        pageNo: action.page
      };
    }
    default:
      return state;
  }
};
